import { render, staticRenderFns } from "./editCityArea.vue?vue&type=template&id=2414447e"
import script from "./editCityArea.vue?vue&type=script&lang=js"
export * from "./editCityArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports